var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns mt-6"},[_c('div',{staticClass:"column mt-6"},[_c('div',{staticClass:"mt-6"},[_c('p',{staticClass:"content subtitle mt-6"},[_vm._v(" 页面开发中 "+_vm._s(_vm.times)+" 秒后，将返回首页! ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }